import { createFileRoute } from '@tanstack/react-router'
import Index from 'pages/index'
import { canonicalLink, ldJsonScript, pageMeta, SITE_URL, websiteSchema } from 'lib/seo'

const HomeTitle = 'Thai to English dictionary, translation and transliteration'
const HomeDescription =
   'Free online Thai to English automatic translation, specially designed to help you learn and understand Thai.'

export const Route = createFileRoute('/')({
   validateSearch: (
      search: Record<string, unknown>
   ): {
      q?: string
      t?: string
      tm?: string
      f?: string
   } => {
      return {
         q: (search.q as string) || undefined,
         t: (search.t as string) || undefined,
         tm: (search.tm as string) || undefined,
         f: (search.f as string) || undefined,
      }
   },
   // With a query this route is a result page: suggestions, a translation, or a
   // brief stop on the way to an entry's own /thai/… or /english/… URL. None of
   // that should be indexed under the query parameter, which is also what the
   // Disallow in robots.txt says.
   head: ({ match }) =>
      match.search.q
         ? { meta: [{ name: 'robots', content: 'noindex' }] }
         : {
              meta: pageMeta({
                 title: HomeTitle,
                 description: HomeDescription,
                 url: `${SITE_URL}/`,
              }),
              links: [canonicalLink(`${SITE_URL}/`)],
              scripts: [
                 ldJsonScript(websiteSchema({ name: HomeTitle, description: HomeDescription })),
              ],
           },
   component: Index,
})
